import { handleResponse } from '@/services/handleresponse'

const API_URL = "https://api.irmastore.id"
// const API_URL = "http://localhost:8081"

export const DigiposService = {
  getDigipostUrl,
  updateUrlModule
}

function getDigipostUrl () {
  return fetch(API_URL + "/api/v1/digipos", {
    method: "GET",
    headers: { 
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
  .then(data => {
    return data
  })
}

function updateUrlModule(data){
  return fetch(API_URL + "/api/v1/digipos", {
    method: "PUT",
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    body: JSON.stringify(data)
  }).then(handleResponse)
  .then(data => {
    return data
  })
}